import {FC, useState} from 'react';
import {Box, Flex, Popover, Portal, Spinner} from '@chakra-ui/react';
import {api, formatDurationMs, useT} from '@kcast-fe/core';
import {Svg} from '@kcast-fe/ui-kit';

interface IProps {
  messageId: string;
  durationMs: number;
}

const WorkedForFC: FC<IProps> = ({messageId, durationMs}) => {
  const [isOpen, setIsOpen] = useState(false);

  const {t} = useT();

  const {data: statuses = [], isLoading} = api.messages.useMessageStatusesQuery(messageId, isOpen);

  return (
    <Popover.Root
      open={isOpen && !isLoading}
      closeOnEscape
      closeOnInteractOutside
      positioning={{placement: 'bottom-start'}}
      onOpenChange={(e) => setIsOpen(e.open)}
    >
      <Popover.Trigger asChild>
        <Flex
          gap={isLoading ? '8px' : '4px'}
          w={'fit-content'}
          alignItems={'center'}
          color={'{colors.textTertiary}'}
          fontSize={'14px'}
          fontWeight={600}
          _hover={{cursor: 'pointer'}}
          data-testid={'worked-for'}
        >
          <Box>{t('labels.workedFor', {duration: formatDurationMs(durationMs)})}</Box>
          {isOpen && isLoading ? (
            <Spinner size={'xs'} />
          ) : (
            <Box rotate={'-90deg'}>
              <Svg name={'ArrowDown'} size={'s16'} />
            </Box>
          )}
        </Flex>
      </Popover.Trigger>
      <Portal>
        <Popover.Positioner borderColor={'transparent'}>
          <Popover.Content
            w={'fit-content'}
            maxW={{base: '400px', smToMd: '320px'}}
            borderRadius={'xl'}
            boxShadow={'{shadows.modal}'}
          >
            <Popover.Body p={{base: '20px 24px', smToMd: '12px 16px'}}>
              {statuses.length === 0 ? (
                <Box color={'{colors.textTertiary}'}>{t('labels.nothingToShow')}</Box>
              ) : (
                <Flex gap={{base: '12px', smToMd: '6px'}} flexDirection={'column'}>
                  {statuses.map((item, i) => (
                    <Box key={i} color={'{colors.textTertiary}'} fontSize={'16px'}>
                      {item.label}
                    </Box>
                  ))}
                </Flex>
              )}
            </Popover.Body>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
};

export const WorkedFor = WorkedForFC;
